"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function SvgAdaptations(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 84 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    height: "100%"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "path-1",
    d: "M0 .023h68.988v25.94H0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Auto/compacto/Adaptaciones",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.5 38c-.82 0-1.486.448-1.5 1h3c-.014-.552-.68-1-1.5-1",
    id: "Fill-1",
    fill: "#CDCDCA",
    transform: "rotate(-180 42.5 38.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.5 38c-.82 0-1.486.448-1.5 1h3c-.014-.552-.68-1-1.5-1",
    id: "Fill-3",
    fill: "#CDCDCA",
    transform: "rotate(-180 54.5 38.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5 12c-.82 0-1.486-.448-1.5-1h3c-.014.552-.68 1-1.5 1",
    id: "Fill-5",
    fill: "#CDCDCA",
    transform: "rotate(-180 42.5 11.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.5 12c-.82 0-1.486-.448-1.5-1h3c-.014.552-.68 1-1.5 1",
    id: "Fill-7",
    fill: "#CDCDCA",
    transform: "rotate(-180 54.5 11.5)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "rotate(-180 38.5 19)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M61.412 25.464s.258-.155 3.758-1.387c1.252-.623 2.285-2.904 3.618-7.186.272-.39.26-7.422 0-7.795-1.333-4.283-2.366-6.564-3.618-7.187C61.67.678 61.412.523 61.412.523c-2.232-.725-8.017-.49-9.531-.346H14.947c-1.363 0-2.723.08-4.076.234C7.817.764 5.4 1.118 2.8 2.077c-3.74 2.228-3.73 19.61 0 21.833 2.599.959 5.016 1.312 8.07 1.665 1.353.155 2.713.234 4.076.234H51.88c1.514.143 7.299.38 9.531-.345",
    id: "Fill-9",
    fill: "#DFDFDC",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M71 36c.378-3.11 1.193-4.913 2.734-5.93a8.857 8.857 0 012.085-.017c.232.023.242.117.024.206-1.828.744-2.447 1.338-2.885 2.195-.642.667-1.291 1.603-1.958 3.546",
    id: "Fill-12",
    fill: "#891214",
    transform: "rotate(-180 73.5 33)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71 36c.216-.888.495-1.637.852-2.266.476-.602.968-1.059 1.522-1.404h-.39c.112-.097.227-.19.347-.277l1.486-.052c.236-.008.245.043.021.122C73.244 32.68 72.196 33.808 71 36",
    id: "Fill-14",
    fill: "#E2272C",
    transform: "rotate(-180 73 34)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71 14c.378 3.11 1.193 4.913 2.734 5.93a8.857 8.857 0 002.085.017c.232-.023.242-.117.024-.206-1.828-.744-2.447-1.338-2.885-2.195C72.316 16.88 71.667 15.943 71 14",
    id: "Fill-16",
    fill: "#891214",
    transform: "rotate(-180 73.5 17)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71 15c.216.888.495 1.637.852 2.266.476.602.968 1.059 1.522 1.404h-.39c.112.097.227.19.347.277l1.486.052c.236.008.245-.043.021-.122C73.244 18.32 72.196 17.192 71 15",
    id: "Fill-18",
    fill: "#E2272C",
    transform: "rotate(-180 73 17)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.204 30.02c-.257.015-.273.103-.037.195 1.834.704 2.852 1.403 3.96 2.997a13.69 13.69 0 011.076 1.867L16 36c-.656-1.494-1.203-2.6-1.816-3.684-.733-1.294-2.14-2.159-3.731-2.284a7.403 7.403 0 00-1.25-.011",
    id: "Fill-20",
    fill: "#AFCDD7",
    transform: "rotate(-180 12.5 33)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 36c-.656-1.494-1.203-2.6-1.816-3.684-.733-1.294-2.14-2.159-3.731-2.284a7.408 7.408 0 00-1.25-.011c-.134.008-.203.036-.203.074 0 .034.055.077.167.12 1.835.704 2.852 1.403 3.96 2.997.418.595.763 1.225 1.076 1.867L16 36m-.37-.56l-1.133-.581a13.597 13.597 0 00-1.06-1.83c-.92-1.322-1.802-2.082-3.262-2.744-.03-.014-.046-.046-.037-.076.008-.03.04-.05.074-.05.096.006.202.014.328.024 1.515.119 2.839.93 3.54 2.166.533.943 1.01 1.891 1.55 3.091",
    id: "Fill-22",
    fill: "#839AA3",
    transform: "rotate(-180 12.5 33)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 35c.375.29.699.615 1 1v-1h-1z",
    id: "Fill-24",
    fill: "#F2F2F2",
    transform: "rotate(-180 12.5 35.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 35.124a4.587 4.587 0 00-.429-.074 12.064 12.064 0 00-.463-.05c-.048-.004-.092.041-.105.107-.012.066.01.136.054.166.334.235.646.476.942.727l.001-.876",
    id: "Fill-26",
    fill: "#D76D00",
    transform: "rotate(-180 14.5 35.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 32a20.319 20.319 0 011 2v-2h-1z",
    id: "Fill-28",
    fill: "#F2F2F2",
    transform: "rotate(-180 11.5 33)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 31c.133.23.267.47.403.72.167.08.373.175.597.28v-1h-1z",
    id: "Fill-30",
    fill: "#F2F2F2",
    transform: "rotate(-180 10.5 31.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 34c.349.31.68.642 1 1v-1h-1z",
    id: "Fill-32",
    fill: "#6C8187",
    transform: "rotate(-180 12.5 34.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 35.938a9.048 9.048 0 00-.429-.036c-.178-.01-.327-.019-.463-.024-.048-.002-.092.02-.105.052-.012.032.01.066.053.081.107.037.21.074.313.112h.63l.001-.185",
    id: "Fill-34",
    fill: "#FFA12F",
    transform: "rotate(-180 14.5 36)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 32h-1c.335.314.667.645 1 1v-1z",
    id: "Fill-36",
    fill: "#6C8187",
    transform: "rotate(-180 11.5 32.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 31l.168.442L11 32v-1h-1z",
    id: "Fill-38",
    fill: "#6C8187",
    transform: "rotate(-180 10.5 31.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.204 19.98c-.257-.015-.273-.103-.037-.195 1.834-.704 2.852-1.403 3.96-2.997.418-.595.762-1.225 1.076-1.867L16 14c-.656 1.494-1.203 2.6-1.816 3.684-.733 1.294-2.14 2.159-3.731 2.284a7.4 7.4 0 01-1.25.011",
    id: "Fill-40",
    fill: "#AFCDD7",
    transform: "rotate(-180 12.5 17)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.203 14.921a13.686 13.686 0 01-1.076 1.867c-1.108 1.594-2.125 2.293-3.96 2.997-.112.043-.167.086-.167.12 0 .038.069.066.204.074.56.03.755.028 1.249-.01 1.591-.126 2.998-.991 3.73-2.285.614-1.083 1.16-2.19 1.817-3.684l-1.797.921m-.123 2.73c-.701 1.237-2.025 2.047-3.54 2.166-.126.01-.232.018-.328.023-.035.002-.066-.019-.074-.049-.01-.03.006-.062.037-.076 1.46-.662 2.343-1.422 3.262-2.745.361-.515.7-1.098 1.06-1.829l1.134-.581a36.616 36.616 0 01-1.551 3.09",
    id: "Fill-42",
    fill: "#839AA3",
    transform: "rotate(-180 12.5 17)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 16c.375-.29.699-.615 1-1v1h-1z",
    id: "Fill-44",
    fill: "#F2F2F2",
    transform: "rotate(-180 12.5 15.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 14.876a4.56 4.56 0 01-.429.074c-.178.022-.327.038-.463.05-.048.004-.092-.041-.105-.107-.012-.066.01-.136.054-.166.334-.235.646-.476.942-.727l.001.876",
    id: "Fill-46",
    fill: "#D76D00",
    transform: "rotate(-180 14.5 14.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 19a20.329 20.329 0 001-2v2h-1z",
    id: "Fill-48",
    fill: "#F2F2F2",
    transform: "rotate(-180 11.5 18)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 19c.133-.23.267-.47.403-.72.167-.08.373-.175.597-.28v1h-1z",
    id: "Fill-50",
    fill: "#F2F2F2",
    transform: "rotate(-180 10.5 18.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 15c-.32.358-.651.689-1 1h1v-1z",
    id: "Fill-52",
    fill: "#6C8187",
    transform: "rotate(-180 12.5 15.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.571 14.098c.144-.008.287-.02.429-.036v-.185h-.631c-.102.038-.206.075-.312.112-.044.015-.066.049-.054.081.013.032.057.054.105.052.136-.005.285-.013.463-.024",
    id: "Fill-54",
    fill: "#FFA12F",
    transform: "rotate(-180 14.5 14)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 17a22.11 22.11 0 01-1 1h1v-1z",
    id: "Fill-56",
    fill: "#6C8187",
    transform: "rotate(-180 11.5 17.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 18l-.832.558L10 19h1v-1z",
    id: "Fill-58",
    fill: "#6C8187",
    transform: "rotate(-180 10.5 18.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.305 35c-3.014-4-3.132-13.922 0-18L69 18.694c-1.23 3.385-1.234 11.154 0 14.612L61.305 35z",
    id: "Fill-60",
    fill: "#2B3D44",
    transform: "rotate(-180 64 26)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.272 25.93c0-1.723.193-3.413.558-4.889.31-1.252.744-2.345 1.27-3.204a.742.742 0 01.793-.343l6.278 1.382c.21.047.34.265.28.478-.452 1.637-.716 4.04-.716 6.624 0 2.588.265 5.009.72 6.669a.382.382 0 01-.281.476l-6.275 1.381a.742.742 0 01-.796-.348c-.52-.866-.95-1.971-1.262-3.242-.372-1.516-.569-3.24-.569-4.984zM69 33.306c-.616-1.728-.924-4.532-.924-7.328 0-2.8.308-5.59.924-7.284L61.305 17C59.755 19.02 59 22.472 59 25.93c0 3.523.784 7.051 2.305 9.07L69 33.306z",
    id: "Fill-62",
    fill: "#1D2A30",
    transform: "rotate(-180 64 26)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.859 16.876c-.711-.624-3.724-1.588-4.986-1.973-6.77-2.069-12.723-2.045-18.282-1.774-3.197.286-5.16.759-7.002 1.687-.288.145-.589.402-.589.757 0 .196.09.348.212.482L60 17l-.141-.124z",
    id: "Fill-64",
    fill: "#2B3D44",
    transform: "rotate(-180 44.5 15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.859 14.885c-.379-.308-1.41-.705-2.481-1.063L29.54 13c-.272.138-.54.367-.54.677 0 .182.09.323.212.448L60 15l-.141-.115z",
    id: "Fill-66",
    fill: "#445D66",
    transform: "rotate(-180 44.5 14)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44 14l.572 2.936L47 17l-1.67-2.979A76.506 76.506 0 0044 14",
    id: "Fill-68",
    fill: "#131313",
    transform: "rotate(-180 45.5 15.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.809 16.663l-29.341-.9a.372.372 0 01-.042-.274c.038-.162.183-.313.41-.427 1.78-.897 3.687-1.355 6.799-1.634 5.006-.244 11.134-.368 18.066 1.75.376.115.734.228 1.074.338 1.49.542 2.523.932 3.034 1.147zm1.05.213c-.711-.624-3.723-1.588-4.986-1.973-6.77-2.069-12.723-2.045-18.282-1.774-3.197.286-5.16.759-7.002 1.687-.288.145-.589.402-.589.757 0 .196.09.348.212.482L60 17l-.141-.124z",
    id: "Fill-70",
    fill: "#131313",
    transform: "rotate(-180 44.5 15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33 15l-3.728-.13L29 13c1.436.538 3.314 1.31 3.858 1.857L33 15z",
    id: "Fill-72",
    fill: "#131313",
    transform: "rotate(-180 31 14)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.859 33.124c-.711.624-3.724 1.588-4.986 1.973-6.77 2.069-12.723 2.045-18.282 1.774-3.197-.286-5.16-.759-7.002-1.687-.288-.145-.589-.402-.589-.757 0-.196.09-.348.212-.482L60 33l-.141.124z",
    id: "Fill-74",
    fill: "#2B3D44",
    transform: "rotate(-180 44.5 35)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.859 35.115L60 35l-30.788.875c-.121.125-.212.266-.212.448 0 .31.268.54.54.677l27.838-.822c1.071-.358 2.102-.755 2.48-1.063",
    id: "Fill-76",
    fill: "#445D66",
    transform: "rotate(-180 44.5 36)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56 35.918l.387-1.907L57 34l-.407 2c-.2-.026-.398-.053-.593-.082",
    id: "Fill-78",
    fill: "#131313",
    transform: "rotate(-180 56.5 35)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44 36l.572-2.936L47 33l-1.67 2.979A76.506 76.506 0 0144 36",
    id: "Fill-80",
    fill: "#131313",
    transform: "rotate(-180 45.5 34.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33 35l-3.728.13L29 37c1.436-.538 3.314-1.31 3.858-1.857L33 35z",
    id: "Fill-82",
    fill: "#131313",
    transform: "rotate(-180 31 36)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.775 34.484c-.34.11-.698.223-1.074.338-6.932 2.118-13.06 1.994-18.066 1.75-3.112-.279-5.019-.737-6.8-1.634-.226-.114-.371-.265-.41-.427a.372.372 0 01.043-.273l29.34-.901c-.51.215-1.542.605-3.033 1.147zM60 33l-30.788.945c-.121.134-.212.286-.212.482 0 .355.3.612.589.757 1.842.928 3.805 1.401 7.002 1.687 5.559.27 11.512.295 18.282-1.774 1.262-.385 4.275-1.35 4.986-1.973L60 33z",
    id: "Fill-84",
    fill: "#131313",
    transform: "rotate(-180 44.5 35)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56 14.082l.387 1.907L57 16l-.407-2c-.2.026-.398.053-.593.082",
    id: "Fill-86",
    fill: "#131313",
    transform: "rotate(-180 56.5 15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.971 37L26 34.431c1.8-3.004 1.8-13.858 0-16.862L36.971 15c2.705 4.449 2.705 17.551 0 22",
    id: "Fill-88",
    fill: "#2B3D44",
    transform: "rotate(-180 32.5 26)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.961 34.35a.403.403 0 01-.279-.54c.747-1.928 1.024-5.178 1.024-7.81 0-2.632-.277-5.882-1.024-7.81a.403.403 0 01.28-.539l9.352-2.19c.365-.085.74.1.897.446.446.986.817 2.29 1.088 3.831.33 1.872.503 4.037.503 6.262 0 2.225-.174 4.39-.503 6.262-.27 1.54-.642 2.845-1.088 3.83a.788.788 0 01-.897.447l-9.353-2.19zM39 26c0-4.388-.676-8.776-2.029-11L26 17.569c.9 1.502 1.35 4.966 1.35 8.431 0 3.465-.45 6.93-1.35 8.431L36.971 37C38.324 34.776 39 30.388 39 26z",
    id: "Fill-90",
    fill: "#1D2A30",
    transform: "rotate(-180 32.5 26)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 15.026c1.288 2.239 1.903 6.602 1.903 10.972 0 4.37-.615 8.737-1.903 10.977.3.075.562-.023.815-.212.336-.25.625-.67.776-1.064 1.951-5.084 1.804-14.7 0-19.401-.148-.387-.434-.811-.776-1.065-.253-.188-.514-.282-.815-.207",
    id: "Fill-92",
    fill: "#131313",
    transform: "rotate(-180 25.5 26)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.745 39.627l-.727-2.296c-.076-.241.091-.383.37-.313 1.744.437 2.403 1.042 2.608 2.483.04.282-.234.525-.563.497l-1.333-.113c-.169-.014-.31-.117-.355-.258",
    id: "Fill-94",
    fill: "#DFDFDC",
    transform: "rotate(-180 32.5 38.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.173 37c-.14.027-.207.155-.156.339l.66 2.392c.041.147.17.254.323.269l-.827-3z",
    id: "Fill-96",
    fill: "#131313",
    transform: "rotate(-180 34.5 38.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.928 38.128a3.33 3.33 0 00-.69-.756c-.146-.116-.321-.225-.194-.316.088-.063.223-.06.322-.052.404.044.823.374 1.08.702.673.844.655 1.738.357 2.111a.504.504 0 01-.237.175c-.067.016-.132.012-.143-.057-.019-.116.303-.632-.495-1.807",
    id: "Fill-98",
    fill: "#F2F2F2",
    transform: "rotate(-180 33 38.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.745 10.373l-.727 2.296c-.076.241.091.383.37.313 1.744-.437 2.403-1.042 2.608-2.483.04-.282-.234-.525-.563-.497l-1.333.113c-.169.014-.31.117-.355.258",
    id: "Fill-100",
    fill: "#DFDFDC",
    transform: "rotate(-180 32.5 11.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.173 13c-.14-.027-.207-.155-.156-.339l.66-2.392A.371.371 0 0135 10l-.827 3z",
    id: "Fill-102",
    fill: "#131313",
    transform: "rotate(-180 34.5 11.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.928 11.872a3.328 3.328 0 01-.69.756c-.146.116-.321.225-.194.316.088.063.223.06.322.052.404-.044.823-.374 1.08-.702.673-.844.655-1.738.357-2.111a.505.505 0 00-.237-.175c-.067-.016-.132-.012-.143.057-.019.116.303.632-.495 1.807",
    id: "Fill-104",
    fill: "#F2F2F2",
    transform: "rotate(-180 33 11.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.207 20.07c-.08.21-.122.315-.207.524 0 .002.213 2.518.238 3.875.007.35.008.705.003 1.055-.024 1.952-.218 3.393-.241 3.882.085.209.126.314.207.525.034.089.117.085.205.027.404-.27.79-.54 1.183-.825.082-.06.136-.201.153-.33a28.892 28.892 0 000-7.606c-.017-.129-.071-.27-.153-.33a36.468 36.468 0 00-1.183-.825c-.09-.059-.17-.061-.205.027",
    id: "Fill-106",
    fill: "#131313",
    transform: "rotate(-180 10 25)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.902 29.88l.1-.065c-.358.057-.538.085-.896.137l.018.048c.312-.046.467-.07.778-.12m-.893-.373l-.005.052a70.837 70.837 0 001.614-.23l.062-.036.008-.023a72.704 72.704 0 01-1.679.237m1.758-.635l.007-.05a79.722 79.722 0 01-1.715.215l-.006.053a80.504 80.504 0 001.714-.218m-1.659-.307l-.005.053a88.096 88.096 0 001.722-.19l.006-.05a92.395 92.395 0 01-1.723.187m.045-.473l-.005.053a103.911 103.911 0 001.726-.163l.005-.05a106.035 106.035 0 01-1.726.16m.037-.475c0 .018-.002.036-.003.053a123.965 123.965 0 001.729-.135l.004-.05a127.245 127.245 0 01-1.73.132m.072-2.382v.08l.87.01.868.01v-.075a744.978 744.978 0 00-1.738-.025m.74-4.05l-.1-.066A57.18 57.18 0 009.124 21l-.02.049c.36.052.539.08.898.137m.685.544a.508.508 0 00-.025-.052A70.878 70.878 0 009 21.44l.004.052a73.147 73.147 0 011.684.237m-1.646.179l.005.053a82.542 82.542 0 011.727.216 15.94 15.94 0 00-.007-.05 79.348 79.348 0 00-1.725-.219m.047.471l.006.054a92.269 92.269 0 011.736.19l-.006-.051a91.195 91.195 0 00-1.736-.193m.046.474l.004.053a108.101 108.101 0 011.74.162l-.005-.05a105.73 105.73 0 00-1.74-.165m.04.475l.005.053a130.778 130.778 0 011.74.133c0-.02-.002-.03-.003-.05a127.227 127.227 0 00-1.741-.136m.033.475l.003.054a167.907 167.907 0 011.741.103l-.003-.05a158.306 158.306 0 00-1.741-.107m.026.477l.002.053a239.115 239.115 0 011.74.074l-.002-.05a225.042 225.042 0 00-1.74-.077m1.758.577l-.001-.052a353.379 353.379 0 00-1.74-.048l.002.055a359.25 359.25 0 011.74.045m-1.73.86v.08A777.054 777.054 0 0011 25.775v-.076a997.178 997.178 0 01-1.736.02m-.006.472l-.002.056a355.644 355.644 0 001.735-.049l.001-.052a362.469 362.469 0 01-1.734.045m-.015.475l-.002.054a246.52 246.52 0 001.733-.076l.002-.05a250.985 250.985 0 01-1.733.072m1.71.374l-.004.05a161.44 161.44 0 01-1.731.106l.003-.054a173.654 173.654 0 001.731-.102",
    id: "Fill-108",
    fill: "#2F302F",
    transform: "rotate(-180 10 25.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.133 30a.179.179 0 01-.107-.058L10 29.909c.238-.626.427-1.256.562-1.887.497-2.309.31-4.64-.562-6.93l.026-.033c.023-.032.06-.05.107-.059.9 2.32 1.1 4.683.596 7.022A13.008 13.008 0 0110.133 30",
    id: "Fill-110",
    fill: "#818181",
    transform: "rotate(-180 10.5 25.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.116 30L10 29.86c.868-2.256 1.059-4.551.568-6.825A12.74 12.74 0 0010 21.14l.116-.14c.925 2.337 1.124 4.718.597 7.074A12.834 12.834 0 0110.116 30",
    id: "Fill-112",
    fill: "#E7E7E7",
    transform: "rotate(-180 10.5 25.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.575 28.009A13.54 13.54 0 019 30l.192-.062c.234-.64.418-1.284.55-1.93.477-2.313.291-4.65-.55-6.946L9.001 21c.86 2.317 1.054 4.674.574 7.009",
    id: "Fill-114",
    fill: "#818181",
    transform: "rotate(-180 9.5 25.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.176 29.944a13.33 13.33 0 00.57-1.967c.475-2.305.283-4.633-.57-6.92A91.794 91.794 0 009.002 21c.25.659.444 1.321.584 1.985.49 2.337.294 4.697-.585 7.015l.176-.056",
    id: "Fill-116",
    fill: "#E7E7E7",
    transform: "rotate(-180 9.5 25.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.546 28.107A14.042 14.042 0 018 30l.229-.074a13.99 13.99 0 00.533-1.964c.445-2.299.266-4.617-.533-6.9L8.041 21c.833 2.352 1.004 4.74.505 7.107",
    id: "Fill-118",
    fill: "#818181",
    transform: "rotate(-180 8.5 25.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.584 23.012c.48 2.328.283 4.676-.584 6.988l.154-.047c.234-.621.423-1.245.56-1.87.511-2.339.336-4.698-.518-7.022A74.263 74.263 0 009 21c.25.668.445 1.34.584 2.012",
    id: "Fill-120",
    fill: "#E7E7E7",
    transform: "rotate(-180 9.5 25.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.501 27.443A11.74 11.74 0 018 29l.26-.075c.221-.584.392-1.17.515-1.757.422-2.036.25-4.086-.514-6.11L8.056 21c.82 2.134.97 4.298.445 6.443",
    id: "Fill-122",
    fill: "#818181",
    transform: "rotate(-180 8.5 25)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.563 22.716C9.059 24.81 8.87 26.92 8 29l.144-.038a11.07 11.07 0 00.531-1.54c.557-2.12.396-4.26-.472-6.369L8.001 21c.238.57.425 1.143.562 1.716",
    id: "Fill-124",
    fill: "#E7E7E7",
    transform: "rotate(-180 8.5 25)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.428 29.676c-.113-.318-.176-.482-.176-.482.034-.69.224-2.3.23-4.194-.006-1.907-.19-3.377-.23-4.193 0 0 .063-.165.176-.482.007-.016.013-.028.054 0 .27.181.88.576 1.098.74.046.03.09.14.102.239v.003a29.244 29.244 0 01.242 3.757c-.007 1.354-.119 2.767-.242 3.633-.01.072-.042.192-.104.24-.302.219-1.15.776-1.096.74-.041.027-.047.015-.054-.001m.098.258c.373-.275 1.13-.904 1.077-.86.11-.09.158-.263.176-.396.143-1.172.22-2.367.22-3.591a29.1 29.1 0 00-.22-3.764v-.003c-.017-.135-.068-.302-.179-.395-.158-.128-.815-.674-1.077-.86a.302.302 0 00-.158-.064c-.046-.006-.127.02-.16.117-.066.175-.134.354-.205.534.049 1.06.223 2.424.218 4.348.005 1.926-.169 3.278-.218 4.349.071.18.14.358.204.534.042.12.158.165.322.05",
    id: "Fill-126",
    fill: "#818181",
    transform: "rotate(-180 10 25)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.43 29.883a20.567 20.567 0 00-.43-.534c.105-1.07.47-2.422.458-4.348.011-1.924-.354-3.29-.458-4.349.15-.18.293-.358.43-.534.07-.097.24-.123.338-.117.066.002.14.01.232.034a.26.26 0 00-.115.083c-.137.176-.28.354-.43.534.104 1.06.47 2.425.458 4.349.012 1.926-.353 3.277-.457 4.348.15.18.292.359.429.534a.248.248 0 00.112.082c-.287.072-.489.026-.568-.082",
    id: "Fill-128",
    fill: "#F2F2F2",
    transform: "rotate(-180 10.5 25)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.07 29.175L11 29c1.973.68 2.422.81 3.619 1.176 1.867.542 2.348.658 3.747.99.053.011 2.005.459 3.805.751 3.297.546 2.374.343 3.829.55-.021.053-.155.437-.192.533-1.47-.249-.298.025-3.727-.636-1.774-.338-3.695-.831-3.805-.858a59.942 59.942 0 01-3.737-1.095c-1.713-.575-2.017-.691-3.47-1.236",
    id: "Fill-130",
    fill: "#CDCDCA",
    transform: "rotate(-180 18.5 31)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.069 20.825L11 21c1.974-.681 2.415-.808 3.612-1.175a59.397 59.397 0 013.75-.99c.053-.012 2.005-.46 3.807-.753 3.3-.546 2.375-.344 3.831-.55-.03-.07-.123-.36-.192-.532-1.47.249-.298-.028-3.729.635-1.775.337-3.697.832-3.807.859a59.932 59.932 0 00-3.74 1.096c-1.713.576-2.01.689-3.463 1.235",
    id: "Fill-132",
    fill: "#CDCDCA",
    transform: "rotate(-180 18.5 19)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76 36c-.455-.138-.91-.292-1.373-.467-3.498-2.144-3.507-18.918 0-21.067.46-.175.914-.329 1.367-.466-.212.359-2.023.69-2.881 4.308l.001-.002c-.435 1.837-.546 4.1-.58 5.987v1.434c.035 1.905.147 4.153.58 5.983l-.001-.002c.85 3.58 2.655 3.976 2.887 4.292",
    id: "Fill-134",
    fill: "#CDCDCA",
    transform: "rotate(-180 74 25)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77 34a6.895 6.895 0 01-.95-.86c-.618-.669-1.167-1.5-1.672-2.508-.22-1.245-.337-2.7-.377-4.4l-.001-.75v-.714c.041-1.7.159-3.155.378-4.4.505-1.008 1.053-1.838 1.671-2.507.3-.324.616-.61.951-.861-2.27 1.852-2.372 6.013-2.372 8.5S74.73 32.149 77 34",
    id: "Fill-136",
    fill: "#F2F2F2",
    transform: "rotate(-180 75.5 25.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.07 33.407c2.1-.313 2.927-.457 4.994-.913a40.928 40.928 0 002.604-.644c6.173-1.77 5.499-2.44-.437-1.256-.975.194-1.872.385-2.525.5a76.967 76.967 0 01-4.886.75c-2.961.321-4.47.415-7.498.51-1.58.046-3.68.091-5.258.042-2.628-.092-3.563-.205-5.47-.449-.9-.138-1.67-.286-2.352-.392-3.847-.597-4.63-.067-.38 1.098.78.213 1.587.39 2.462.577 1.989.362 2.986.522 5.662.695 1.667.097 3.719.084 5.385.049 3.055-.079 4.629-.18 7.699-.567",
    id: "Fill-138",
    fill: "#F2F2F2",
    transform: "rotate(-180 47 32)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.07 16.593c2.1.313 2.927.457 4.994.913.766.166 1.676.378 2.604.644 6.173 1.77 5.499 2.44-.437 1.256-.975-.195-1.872-.385-2.525-.5a76.917 76.917 0 00-4.886-.75c-2.961-.321-4.47-.415-7.498-.51-1.58-.046-3.68-.091-5.258-.042-2.628.092-3.563.205-5.47.449-.9.138-1.67.286-2.352.392-3.847.597-4.63.067-.38-1.098.78-.213 1.587-.39 2.462-.577 1.989-.362 2.986-.522 5.662-.695 1.667-.097 3.719-.084 5.385-.049 3.055.079 4.629.18 7.699.567",
    id: "Fill-140",
    fill: "#F2F2F2",
    transform: "rotate(-180 47 18)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.312 30.346c-3.93-.836-4.73-.093-.389 1.538.797.3 1.622.547 2.516.808.465.117.877.218 1.269.308.083-.526.175-1.015.277-1.458a.558.558 0 00-.081-.443c-.367-.06-.753-.127-1.189-.203-.92-.194-1.707-.402-2.403-.55",
    id: "Fill-142",
    fill: "#445D66",
    transform: "rotate(-180 62.5 31.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.477 34.005c6.446-1.918 5.741-2.644-.456-1.361-1.019.21-1.955.417-2.637.541-.488.09-.9.167-1.294.238a.351.351 0 00-.062.372c.151.357.283.764.398 1.205.396-.085.828-.182 1.332-.297.8-.18 1.75-.41 2.719-.698",
    id: "Fill-144",
    fill: "#445D66",
    transform: "rotate(-180 33.5 33.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.386 30.448c-.142.449-.27.943-.386 1.475l.471.077c.15-.703.326-1.349.529-1.917-.24-.026-.48-.054-.727-.083a.443.443 0 01.113.448",
    id: "Fill-146",
    fill: "#31444C",
    transform: "rotate(-180 59.5 31)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39 32.91a11.443 11.443 0 00-.437-1.459.46.46 0 01.069-.451l-.632.122c.238.503.444 1.142.617 1.878.125-.029.252-.058.383-.09",
    id: "Fill-148",
    fill: "#31444C",
    transform: "rotate(-180 38.5 32)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.02 18.356c6.198 1.283 6.903.557.457-1.36a41.401 41.401 0 00-2.72-.699c-.503-.115-.935-.212-1.331-.297a8.793 8.793 0 01-.398 1.206.351.351 0 00.062.371c.394.07.806.147 1.294.238.682.124 1.618.33 2.637.541",
    id: "Fill-150",
    fill: "#445D66",
    transform: "rotate(-180 33.5 17.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.986 18.46A21.89 21.89 0 0165.71 17c-.393.09-.806.192-1.273.308-.894.262-1.718.51-2.515.809-4.34 1.63-3.54 2.373.389 1.537.695-.148 1.482-.356 2.402-.55.437-.076.824-.143 1.191-.203a.557.557 0 00.082-.441",
    id: "Fill-152",
    fill: "#445D66",
    transform: "rotate(-180 62.5 18.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59 18.077c.115.532.244 1.027.386 1.477a.441.441 0 01-.114.446c.247-.03.489-.056.728-.082A15.502 15.502 0 0159.473 18l-.473.077",
    id: "Fill-154",
    fill: "#31444C",
    transform: "rotate(-180 59.5 19)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.563 18.55c.166-.433.311-.926.437-1.46-.13-.032-.258-.061-.383-.09-.173.736-.379 1.375-.617 1.879.21.039.418.08.631.121a.46.46 0 01-.068-.45",
    id: "Fill-156",
    fill: "#31444C",
    transform: "rotate(-180 38.5 18)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39 17.304c3.27-.367 6.067-.327 9.114-.26 4.129.093 7.395.361 10.886.928l-.02.028c-3.488-.567-6.74-.833-10.867-.925-3.045-.068-5.834-.109-9.1.258l-.013-.03z",
    id: "Fill-158",
    fill: "#9A9A9A",
    transform: "rotate(-180 49 17.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39 32.696l.013-.03c3.267.367 6.055.327 9.1.26 4.125-.093 7.378-.36 10.866-.926l.021.029c-3.49.566-6.759.834-10.886.926-3.046.068-5.845.108-9.114-.259",
    id: "Fill-160",
    fill: "#9A9A9A",
    transform: "rotate(-180 49 32.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66 16.129c.188-.094.38-.16.575-.115l.17.039c1.944.442 4.577 1 6.232.814l.023.095c-1.656.187-4.312-.358-6.258-.8l-.17-.04c-.192-.043-.366.03-.552.122L66 16.13z",
    id: "Fill-162",
    fill: "#9A9A9A",
    transform: "rotate(-180 69.5 16.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66 34.911l.017-.092a.8.8 0 00.555.052l.175-.04c1.944-.433 4.598-.978 6.253-.795l-.024.096c-1.653-.183-4.283.373-6.226.806l-.175.04A.852.852 0 0166 34.91",
    id: "Fill-164",
    fill: "#9A9A9A",
    transform: "rotate(-180 69.5 34.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59 12l.038.001c.631.755 1.124 1.217 1.77 1.818L61 14h-.066l-.164-.152A18.608 18.608 0 0159 12",
    id: "Fill-166",
    fill: "#9A9A9A",
    transform: "rotate(-180 60 13)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 12l.134.001c.515.36.77.658.866.995l-.122.004c-.095-.33-.37-.645-.878-1",
    id: "Fill-168",
    fill: "#9A9A9A",
    transform: "rotate(-180 28.5 12.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59 38a18.667 18.667 0 011.774-1.847L60.94 36H61l-.187.182a18.03 18.03 0 00-1.737 1.816L59 38z",
    id: "Fill-170",
    fill: "#9A9A9A",
    transform: "rotate(-180 60 37)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 38c.508-.355.783-.67.878-1l.122.004c-.096.337-.35.634-.866.995L28 38z",
    id: "Fill-172",
    fill: "#9A9A9A",
    transform: "rotate(-180 28.5 37.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.276 36.972l.143-.077c.359-.188.576-.522.581-.895l-.119.029c-.004.325-.19.595-.521.768-.12.063-.244.138-.36.203l.276-.028z",
    id: "Fill-174",
    fill: "#9A9A9A",
    transform: "rotate(-180 72.5 36.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.444 13.132a10.19 10.19 0 01-.183-.106L72 13c.126.076.257.161.387.234.32.18.498.397.502.735L73 14c-.004-.388-.209-.672-.556-.868",
    id: "Fill-176",
    fill: "#9A9A9A",
    transform: "rotate(-180 72.5 13.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.959 36.951L17 37l-.05-.003a1.028 1.028 0 00-.376-.292L15 36l.104.015 1.49.663a.996.996 0 01.365.273",
    id: "Fill-178",
    fill: "#9A9A9A",
    transform: "rotate(-180 16 36.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.937 13.072L17 13l-.05.003a1.17 1.17 0 01-.402.317L15 14l.079-.011 1.489-.642c.15-.067.277-.163.369-.275",
    id: "Fill-180",
    fill: "#9A9A9A",
    transform: "rotate(-180 16 13.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.254 35.249c-2.028-.296-3.525-.253-6.123.133a1 1 0 00-.131-.018c2.756-.419 4.168-.477 6.263-.171.71.104 1.31.216 1.89.324 1.585.297 2.838.532 5.185.38l.61-.041.052.043-.657.055c-2.355.152-3.675-.095-5.203-.381-.578-.109-1.177-.22-1.886-.324",
    id: "Fill-182",
    fill: "#9A9A9A",
    transform: "rotate(-180 20 35.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.254 14.751c-2.028.296-3.525.253-6.123-.133a.992.992 0 01-.131.018c2.756.419 4.168.477 6.263.17.71-.103 1.31-.215 1.89-.323 1.585-.297 2.838-.532 5.185-.38l.61.041.052-.043-.657-.055c-2.355-.152-3.675.095-5.203.381-.578.109-1.177.22-1.886.324",
    id: "Fill-184",
    fill: "#9A9A9A",
    transform: "rotate(-180 20 14.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-186",
    fill: "#9A9A9A",
    transform: "rotate(-180 9 20.5)",
    d: "M8.88 21l.194-.954.047-.046-.2.974z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-188",
    fill: "#9A9A9A",
    transform: "rotate(-180 9 29.5)",
    d: "M8.878 29l.043.026.201.974-.046-.042z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.96 12.002L45.922 12c.002.015.152.956.114 1.997l.036.003a11.534 11.534 0 00-.112-1.998",
    id: "Fill-190",
    fill: "#9A9A9A",
    transform: "rotate(-180 46 13)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47 17l-.963-3H46l.964 2.999L47 17z",
    id: "Fill-192",
    fill: "#4C4C4C",
    transform: "rotate(-180 46.5 15.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.96 37.998l-.038.002c.002-.015.152-.956.114-1.997l.036-.003a11.534 11.534 0 01-.112 1.998",
    id: "Fill-194",
    fill: "#9A9A9A",
    transform: "rotate(-180 46 37)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47 33l-.963 3H46l.964-2.999L47 33z",
    id: "Fill-196",
    fill: "#4C4C4C",
    transform: "rotate(-180 46.5 34.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.776 13.04c-.154 0-.301.018-.427.058-.188.06-.299.156-.312.27-.013.115.073.238.242.346.358.23.974.314 1.372.188.188-.06.299-.156.312-.27.013-.115-.073-.238-.242-.346-.245-.158-.61-.247-.945-.247m.45.961c-.342 0-.715-.09-.966-.251-.181-.117-.273-.254-.258-.385.015-.132.134-.24.337-.304.407-.129 1.035-.043 1.4.191.182.117.274.254.26.385-.016.132-.135.24-.338.304-.128.04-.279.06-.436.06",
    id: "Fill-198",
    fill: "#9A9A9A",
    transform: "rotate(-180 68 13.5)"
  })));
}
var _default = exports["default"] = SvgAdaptations;